import React from "react";

const Text = ({ text }) => <h2>{text}</h2>;

export default Text;
